define('collections/timezones',["jQuery", "T1", "T1Collection", "models/timezone"], function ($, T1, T1Collection, Timezone) {
  T1.Models.Timezones = T1Collection.extend({
    model: Timezone,
    name: "timezones",
    urlString: "timezones"
  });
  return T1.Models.Timezones;
});
